export function getBookmarksState(state, bookmark) {
  if (state === void 0) {
    state = {};
  }
  if (bookmark === void 0) {
    bookmark = {};
  }
  return {
    ...state,
    bookmarks: {
      ...state.bookmarks,
      ...bookmark
    }
  };
}

/**
 * updates supplied state object with all modals closed
 * @param  {Object} state
 * @return {Object} state
 */
export function getClosedModalState(state) {
  if (state === void 0) {
    state = {};
  }
  return {
    ...state,
    showQuickSaveNotification: false,
    showQuickSaveList: false,
    showUpdateSavedInventory: false,
    showUpdateSavedSearch: false,
    showEmailSubscribeModal: false,
    showUpdateAlertsModal: false,
    showUpdateCancelAccountModal: false
  };
}
export function getDefaultEmailRegistrationState(state) {
  if (state === void 0) {
    state = {};
  }
  return {
    ...state,
    showEmailSubscribeFailure: false,
    showEmailSubscribeSuccess: false,
    showBestDealsSubscribeSuccess: false,
    showNewUserModal: false,
    emailRegistrationError: '',
    bestDealsRegistrationError: ''
  };
}
export const globalAlerts = {
  expiredListings: {
    bsStyle: 'warning',
    message: 'Looks like some of your saved listings have expired. We\'ve removed those for you.'
  },
  alertsSuccess: {
    bsStyle: 'info'
  },
  cancelAlertsSuccess: {
    bsStyle: 'info',
    message: 'We have successfully updated your preferences'
  },
  conversionFailure: {
    bsStyle: 'danger',
    message: 'Oops, something went wrong. We’re working to get it fixed. Sign in again to permanently save your vehicles.'
  },
  serverFailure: {
    bsStyle: 'danger',
    message: 'Oops, something went wrong. We\'re working to get it fixed. Try saving your item again.'
  }
};